import { useContext, useEffect, useRef, useState } from 'react';
import PassengerTable from './PassengerTable';
import BookSummary from './OrderSummary';
import { useTranslation } from 'react-i18next';
import { delay, getBase64Screenshot, openInNewWindow } from 'utils/utils';
import { submitScreenshots } from 'services/hotel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/ui/Button/Button';
import { useNavigate } from 'react-router-dom';
import { getHotelIndex, getKey } from 'utils/hotel';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import useDataLayer from 'hooks/useHotelDataLayer';
import { MainContext } from 'contexts/MainContext';
import { HotelConfigContext } from 'contexts/HotelConfigContext';
import { b2b, needToScreenshot } from 'constants/generic';

const SuccessPage = () => {
  const { t } = useTranslation();
  const [order, setOrder] = useState<any>();
  const successRef = useRef<HTMLDivElement>(null);
  const { hotelIndex } = useContext(HotelConfigContext);
  const { userSiteConfig, initSiteData } = useContext(MainContext);
  const { pushHotelPurchase } = useDataLayer();
  const navigate = useNavigate();
  useGetPage('Hotels/BookComplete');
  useEffect(() => {
    const orderStr = sessionStorage.getItem(getKey('bookSuccessHotels', hotelIndex));
    if (orderStr) {
      const order = JSON.parse(orderStr);
      setOrder(order);

      (async () => {
        await delay(1000);
        pushHotelPurchase();

        if (needToScreenshot && !order.screenshot) {
          const image = await getBase64Screenshot(successRef.current);

          submitScreenshots({
            screenshots: [],
            orderId: order.orderId,
            lastScreenshot: image,
            transactionId: order.tranasctionId,
          });
          sessionStorage.setItem(
            getKey('bookSuccessHotels', hotelIndex),
            JSON.stringify({ ...order, screenshot: true })
          );
        }
      })();
    }
  }, []); // eslint-disable-line

  const navigateToMo = () => {
    if (userSiteConfig?.base?.openDetailsInNewTab) {
      openInNewWindow('/my-orders?orderId=' + order.orderId);
    } else {
      navigate('/my-orders?orderId=' + order.orderId);
    }
  };

  const onClickSearchAgain = () => {
    const lastSearchUrl = sessionStorage.getItem(getKey('lasestSearchUrl', hotelIndex));
    if (lastSearchUrl) {
      navigate({ pathname: '/hotels' + getHotelIndex(hotelIndex) + '/results', search: lastSearchUrl + '&needToSearch=false' });
    }
  };

  return (
    <div className="success page-wrapper" ref={successRef}>
      <div className="title">
        {t('hotel.order_summary')} #{order?.orderId}
      </div>
      {order?.book?.statusIsOK ? (
        <div className="mb-20"></div>
      ) : (
        <div className="mb-20">
          <FontAwesomeIcon className="color-danger mr-5" icon={faExclamationTriangle} />
          <span className="text-md">{t('failed_order')}</span>
        </div>
      )}
      {order?.orderHasBeenPaid && (
        <div className="text-md mb-20">{t('hotel.paid_successfully')}</div>
      )}
      {(b2b || (initSiteData?.companyId === 135)) && (
        <div className="mb-20">
          <Button
            title={t('mo.display_order')}
            onClick={() => navigateToMo()}
            className="btn btn-primary mr-5"
          />
          <Button
            title={t('mo.search_again')}
            onClick={onClickSearchAgain}
            className="btn btn-primary mr-5"
          />
        </div>
      )}

      {!!order?.book && <BookSummary book={order.book} isSuccess={true} />}
      <div className="mb-20"></div>
      <div className="title text-md text-left">{t('passenger.details')}</div>
      <div className="details-block default-shadow">
        {order?.paxes && <PassengerTable paxes={order?.paxes} />}
      </div>
    </div>
  );
};

export default withErrorBoundary(SuccessPage, 'SuccessPage');
